<template>
  <div class="page_body">
    <div class="data_main">
      <div class="form_main">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="small"
          label-width="110px"
        >
          <el-form-item label="文章标题：" prop="question">
            <el-input
              v-model="form.question"
              placeholder="请输入文章标题"
            ></el-input>
          </el-form-item>

          <el-form-item label="文章排序：" prop="sort">
            <el-input
              v-model="form.sort"
              placeholder="请输入文章排序"
              maxlength="5"
            ></el-input>
          </el-form-item>

          <el-form-item label="文章内容：" prop="detail">
            <tinymceEditor
              :content="form.answer"
              @changeValue="getDetails"
            ></tinymceEditor>
            <!-- <tinymceEditor :content="form.detail" @changeValue="getDetails" v-if='form.type==4'></tinymceEditor>
                      <tinymceEditorOld :content="form.detail" @changeValue="getDetails" v-if='form.type!=4'></tinymceEditorOld> -->
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="isSubmitLoading"
              @click="submitFormAdd('form')"
              >提 交</el-button
            >
            <el-button @click="$refs['form'].resetFields()">重 置</el-button>
            <el-button @click="$router.go(-1)">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import tinymceEditor from "@/components/tinymceEditor";
// import tinymceEditorOld from "@/components/tinymceEditorOld";
import { postFaq } from "@/api";
export default {
  name: "noticeAdd",
  data() {
    return {
      form: {
        question: "",
        answer: "",
        sort: 0,
      },
      inputVisible: false,
      inputValue: "",
      isSubmitLoading: false,
      isRequestLoading: false,
      rules: {
        question: [
          { required: true, message: "请输入文章标题", trigger: "blur" },
        ],
        sort: [
          { required: true, message: "请输入文章排序", trigger: "blur" },
          { max: 5, message: "排序最多五个字", trigger: "blur" },
          { pattern: "^[0-9]+$", message: "请输入数字", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
  },
  methods: {
    getDetails(e){
      this.form.answer = e;
    },
    submitFormAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postFaq({
            data: this.form,
          })
            .then((res) => {
              this.isSubmitLoading = false;
              if (res.code === 0) {
                this.$message({
                  message: "常见问题发布成功",
                  type: "success",
                  showClose: true,
                });
                this.$refs["form"].resetFields();
                this.$router.go(-1);
              }
            })
            .catch(() => {
              this.isSubmitLoading = false;
            });
        }
      });
    },
  },
  components: {
    tinymceEditor,
    // tinymceEditorOld
  },
};
</script>
<style scoped lang='scss'>
.el-tag {
  margin-right: 10px !important;
}
.button-new-tag {
  margin-right: 10px !important;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px !important;
  margin-right: 10px !important;
  vertical-align: bottom;
}
.synopsis {
  position: relative;
  /deep/.el-textarea__inner {
    min-height: 100px !important;
  }
  /deep/.el-input__count {
    position: absolute;
    left: 430px;
    bottom: 4px;
    width: 53px;
    text-align: right;
  }
}
</style>
